import styled from '@emotion/styled';
import { Button as ButtonMUI } from '@mui/material';

export const Button = styled(ButtonMUI)`
  color: ${({ theme }) => theme.color.white};
`;
